<template>
  <v-menu class="searchBoxWrapper" v-model="showSearchFilter" :close-on-content-click="false" :open-on-click="false" :close-on-click="false" :allow-overflow="true" :offset-y="true" :full-width="true">
    <div slot="activator" class="searchCompany elevation-4">
      <v-menu :id="id+'menu'" bottom :close-on-click="true" :disabled="!countries || countries.length <= 1">
        <template v-slot:activator="{ on, attrs }">
          <div id="countryselector" class="countrySelector" align-center v-bind="attrs" v-on="on">
            <span class="selectorContent">
              <span class="flagImageCountrySearch">
                <v-img class="flagImageCountrySearch" :src="countryFlag" :alt="selectedCountry"/>
              </span>
              <span class="searchCountrytext" align-center v-text="selectedCountry"></span>
              <i v-if="countries && countries.length > 1" aria-hidden="true" class="v-icon material-icons theme--light error--text searchArrowDropDown">arrow_drop_down</i>
            </span>
          </div>
        </template>
        <v-list>
          <template v-for="(item, index) in countries">
            <v-hover v-slot:default="{ hover }" :key="index">
              <v-list-tile class="countrySelectionItem" :class="hover ? 'elevation-2' : ''" @click="changeCountry(item)">
                <v-list-tile-action class="pa-1">
                  <v-img class="flagImageCountrySearch" :src="item.flag" :alt="item.code"/>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.code }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-hover>
          </template>
        </v-list>
      </v-menu>

      <v-text-field id="search-input" clearable hide-details autofocus class="searchCompanyText" tabindex="1" v-model="searchCompanyText" :placeholder="placeHolder" @blur="handleBlur" @focus="onFocus" @input="handleInput" @click:clear="showSearchFilter = false" @keydown.enter="validateInput">
        <template v-slot:append>
           <div class="icon-search-company-container"><span v-show="showTextFieldSearchIcon" v-on:click="validateInput()" :class="searchIconClassObject"></span></div>
        </template>
      </v-text-field>
    </div>

    <v-card class="searchFilters">
      <v-card-text>
        <v-form ref="filtersForm">
          <v-layout row>
            <v-text-field ref="searchFilterStateCode" v-model="searchCompanyState" tabindex="2" label="State code" placeholder="E.g. FL" clearable :rules="[validationRules.required, validationRules.stateCodeMaxLength]"></v-text-field>
          </v-layout>
          <v-layout row>
            <v-text-field v-model="searchCompanyCity" tabindex="3" label="City" placeholder="E.g. Miami" md6 style="margin-right: 12px;" clearable :rules="[validationRules.required]"></v-text-field>
            <v-text-field v-model="searchCompanyZip" tabindex="4" label="Zip code" placeholder="E.g. 14284" md6 style="margin-left: 12px;" clearable :rules="[validationRules.required]"></v-text-field>
          </v-layout>
          <v-layout row>
            <v-text-field v-model="searchCompanyPhone" tabindex="5" label="Business phone (Optional)" placeholder="E.g. +1 305-856-1188" md6 clearable></v-text-field>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="search-button" tabindex="6" color="primary" @click="validateInput()"><v-icon left class="search-button-icon">&#xe925;</v-icon>{{$t('Cover.ListCover.SEARCH_COMPANY_BTN')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ['id', 'countryFlag', 'selectedCountry', 'searchFilterIsEnabled', 'searchByIdTriggerRules', 'placeHolder', 'countries'],
  data () {
    return {
      searchCountry: null,
      searchCompanyText: '',
      searchCompanyState: '',
      searchCompanyCity: '',
      searchCompanyZip: '',
      searchCompanyPhone: '',
      searchIcon: require(`@/assets/img/searchicon.svg`),
      showSearchFilter: false,
      isSearchById: false,
      validationRules: {
        required: value => !!value || 'Required.',
        stateCodeMaxLength: value => value.length === 2 || this.$t('Company.SelectCompany.STATE_CODE_MAX_LENGTH_RULE')
      }
    }
  },
  watch: {
    showSearchFilter (val) {
      // used to set the focus into the popover when search filters are displayed to prevent issues on tab navigation
      if (val) {
        setTimeout(() => this.showing(), 100)
      }
    }
  },
  methods: {
    onFocus () {
      if ($('#countryselector').hasClass('countrySelector')) {
        $('#countryselector').removeClass('countrySelector')
        $('#countryselector').addClass('countrySelectorHilighted')
      }
    },
    handleBlur () {
      if ($('#countryselector').hasClass('countrySelectorHilighted')) {
        $('#countryselector').removeClass('countrySelectorHilighted')
        $('#countryselector').addClass('countrySelector')
      }
    },
    showing () {
      this.$refs.searchFilterStateCode.focus()
    },
    async handleInput () {
      this.onFocus()
      this.isSearchById = this.searchByIdTriggerRules && this.searchCompanyText && this.searchByIdTriggerRules.some(x => x.rule.test(this.searchCompanyText.trim()))
      if (this.isSearchById) {
        this.showSearchFilter = false
      }
    },
    async validateInput () {
      this.isSearchById = this.searchByIdTriggerRules && this.searchCompanyText && this.searchByIdTriggerRules.some(x => x.rule.test(this.searchCompanyText.trim()))

      // no need to display filters
      if (this.isSearchById || !this.searchFilterIsEnabled || (this.showSearchFilter && this.$refs.filtersForm.validate())) {
        this.showSearchFilter = false
        this.$emit('initializeResult')
        this.$emit('showResult')
        this.$emit('searchListCompanies', {
          isSearchById: this.isSearchById,
          text: this.searchCompanyText,
          state: this.searchCompanyState,
          city: this.searchCompanyCity,
          postCode: this.searchCompanyZip,
          phone: this.getSanitizedPhoneNumber(this.searchCompanyPhone)
        })
      } else {
        // display additionnal filters only if not an id
        this.$emit('initializeResult')
        this.$emit('hideResult')
        this.showSearchFilter = true
      }
    },
    getSanitizedPhoneNumber (value) {
      if (!value) {
        return value
      }
      return value.replace(/\D/g, '')
    },
    changeCountry (country) {
      this.resetSearch()
      this.$emit('selectedCountryChanged', country)
    },
    resetSearch () {
      this.showSearchFilter = false
      this.$emit('initializeResult')
      this.$emit('hideResult')
      this.searchCompanyText = ''
      this.searchCompanyState = ''
      this.searchCompanyCity = ''
      this.searchCompanyZip = ''
      this.searchCompanyPhone = ''
    }
  },
  computed: {
    showTextFieldSearchIcon: function () {
      return this.showSearchFilter || (this.searchCompanyText && this.searchCompanyText.length > 0)
    },
    searchIconClassObject: function () {
      return {
        'icon-right-arrow': !this.isSearchById && this.searchFilterIsEnabled,
        'icon-search': this.isSearchById || !this.searchFilterIsEnabled,
        'icon-enabled icon-search-company': true
      }
    }
  }
}
</script>
<style>
.searchBoxWrapper {
  width: 100%;
}
.searchCompany {
  display: inline-flex;
  width: 100%;
  height: 50px;
  background-color: #fcfdfd;
  border-radius: 4px;
}
.countrySelector {
  background-color: #fcfdfd;
  width: 88px;
  height: 50px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--primary-color);
  border-bottom: 1px solid #e8e8e8;
}
.countrySelectorHilighted {
  background-color: #fcfdfd;
  width: 88px;
  height: 50px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--primary-color);
  border: 1px solid #fa9375;
}

.countrySelectionItem {
  color: var(--primary-color);
  cursor: pointer;
}

.countrySelectionItem:hover {
  background-color: #f0f0f0;
}

.countrySelectionItem > .v-list__tile {
  height: 36px;
  padding: 0px 7px;
}

.countrySelectionItem > .v-list__tile > .v-list__tile__action {
  min-width: 48px !important;
}

.searchCompany > .v-menu__content {
  min-width: 87px;
}

.selectorContent{
  margin-left: 16px;
  margin-top: 16px;
  display: flex;
}

.selectorContent > .theme--light.v-icon {
   color: var(--primary-color) !important;
}

.flagImageCountrySearch{
    width: 24px;
    max-width: 24px;
    height: 18px;
    max-height: 18px;
    object-fit: contain;
}
.searchCountrytext{
   margin-left: 7px;
}
.searchArrowDropDown{
  font-size: 20px;
}
.companyTitle{
  font-size: 15px;
  font-weight: bold;
}
.v-autocomplete__content.v-menu__content {
    max-width: 464px;
}
.smalltext {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #9ca6ba;
}

.imageCountrySearch{
    width: 18px;
    height: 18px;
    object-fit: contain;
}

.icon-search-company-container {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 5px;
  background-color: rgba(0, 0, 0, 0);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.icon-search-company {
    cursor: pointer;
    padding: 4px;
    border-radius: 26px;
    height: 33px;
    line-height: 1.5;
}

.searchCompanyText {
  height: 50px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
}

#search-input {
  cursor: text;
}

.searchCompanyText .v-input__slot {
  height: 50px;
  border-radius: 0px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.v-menu__content {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  margin-top: -2px;
}

.searchFilters > .v-card__text {
  padding: 26px;
}
.searchFilters > .v-card__actions {
  padding: 26px;
  padding-top: 0px;
}
.searchFilters > .v-card__text > .container {
  padding: 0px;
}
.search-button {
  padding: 0px 40px;
}
.search-button-icon {
  font-family: 'sic-icon-font';
  color: rgb(255, 255, 255);;
}
</style>
